exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".instruction_area{\n    height: 500px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/member-perks-list/member-perks-list.component.css
// module id = 426
// module chunks = 0